"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Welcome_component_1 = require("./Welcome.component");
exports.Welcome = Welcome_component_1.Welcome;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9Wb2d1ZS9mb3JtL1dlbGNvbWUvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx5REFBMkM7QUFBbkMsc0NBQUEsT0FBTyxDQUFBIn0=